'use client';

import { usePathname } from 'next/navigation';
import AdminShell from './AdminShell';

// 공개(관리자 셸 미적용) 라우트: 로그인, 루트(→/dashboard 리다이렉트), 세금계산서(현행 무-셸 유지)
function isPublicRoute(pathname: string): boolean {
  if (pathname === '/' || pathname === '/login') return true;
  if (pathname.startsWith('/login')) return true;
  if (pathname.startsWith('/tax-invoices')) return true;
  return false;
}

// AdminShell을 지속 레이아웃에서 1회만 렌더 → 페이지 이동 시 셸/사이드바/인증상태/알림 SSE 보존.
// (각 page.tsx 내부의 <AdminShell>은 중첩 감지로 passthrough 동작)
export default function AdminLayoutGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? '';
  if (isPublicRoute(pathname)) return <>{children}</>;
  return <AdminShell>{children}</AdminShell>;
}
